var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('p',[_vm._v(" Error: Configuration has been disabled on this instance. Please contact your administrator for more information. ")])])
}]

export { render, staticRenderFns }